export default __webpack_public_path__ + "assets/b9bff74ad2f92b10cb0c3dfc87172630.png";